const getMuiSelectIntro = () => {
    return `
    //CUSTOMMUISELECT
    const CustomMuiSelect = ({ data = [], name, label, selected, handleSelect = () => null, width = 200, itemText = "text", itemValue = "value", hasEmpty }) => {
    }
    export default CustomMuiSelect;
    `;
}

export default getMuiSelectIntro;
